import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@tsin-env/environment';
import { ConferenceRequestInput, IApproverConference, IConferenceRequest } from './interface';

const API_URI = `${environment.apiBaseUrl}/request-form`;
@Injectable({
    providedIn: 'root'
})
export class ConfereceService {
    http: HttpClient = inject(HttpClient);

    getRequests(queryParams: { formTitle: string }) {
        return this.http.get<IConferenceRequest[]>(API_URI, { params: queryParams });
    }

    createConferenceForm(input: ConferenceRequestInput) {
        return this.http.post(`${API_URI}/create/conference-form`, input);
    }

    getSingle(id: string) {
        return this.http.get<IConferenceRequest>(`${API_URI}/single/${id}`);
    }

    getByUser(input: { id: string; query: string }) {
        return this.http.get<IConferenceRequest[]>(
            `${API_URI}/user/${input.id}?formTitle=${input.query}`
        );
    }

    getApproverRequests(input: { id: string; query: string }) {
        return this.http.get<IApproverConference[]>(
            `${API_URI}/assigned-requests/${input.id}?formTitle=${input.query}`
        );
    }
}
